import React from 'react';
import { Button } from '@material-ui/core';
import styled from 'styled-components/macro';
import { previewFileActions } from '../../store/actions';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import loadingImg from '../../assets/images/spinner.gif';
import { useDispatch } from 'react-redux';

const PreviewEmailButton = ({
  bodyPreviewUrl,
  isLoading,
  label = 'Preview Email Body',
  variant = 'outlined' as any,
}) => {
  const dispatch = useDispatch();
  const handleOnClick = (e) => {
    if (bodyPreviewUrl) {
      dispatch(
        previewFileActions.show(bodyPreviewUrl, 'application/pdf'),
      );
    } else console.error(`bodyPreviewUrl is missing`);
  };
  return (
    <Button
      variant={variant}
      color="primary"
      onClick={(e) => handleOnClick(e)}
      startIcon={
        isLoading ? (
          <SSpinnerImg src={loadingImg} />
        ) : (
          <MailOutlineIcon />
        )
      }
    >
      {label}
    </Button>
  );
};

export default PreviewEmailButton;
const SSpinnerImg = styled.img`
  width: 25px;
`;
